import { render, staticRenderFns } from "./EditMessageTemplateDialog.vue?vue&type=template&id=64c97362&"
import script from "./EditMessageTemplateDialog.vue?vue&type=script&lang=js&"
export * from "./EditMessageTemplateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports